import { Injectable } from '@angular/core';

import { ConfigService } from '../../services/config.service';
import { timeout } from 'rxjs/operators';
import { ControlCentreApiClient, RemoteOrderRequest } from '../../api-module/control-centre-api-client';

const HTTP_TIMEOUT_MSECONDS = 15000;

@Injectable({
    providedIn: 'root'
})
export class OrderService {
    apiServer = ConfigService.settings.apiServer.controlCenter;

    constructor(private controlCentreApiClient: ControlCentreApiClient) {}

    saveOrder(order: RemoteOrderRequest) {
        return this.controlCentreApiClient.remoteOrder_Add(order).pipe(timeout(HTTP_TIMEOUT_MSECONDS));
    }
}
